import React from 'react';

import {useUserRoles} from 'src/hooks/useUserRoles';
import {Role} from 'src/openapi/models/Role';

import Button from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    onAiAssist: () => void,
    inReview: boolean,
};

export const ChangeRequestReviewView = ({onAiAssist, inReview}: Props) => {
    const userRoles = useUserRoles();

    return (
        <>
            {userRoles.includes(Role.ROLE_UDEDT_REVIEWER) ? (
                <Group alignItems="center">
                    <Button disabled={inReview} variant="Type.PRIMARY" onClick={onAiAssist}>
                        AI Review
                    </Button>
                    {inReview ? (
                        <Group>
                            <Loading fast={true} type={Types.ICON}/>
                            <Item>Review in progress...</Item>
                        </Group>
                    ) : null}
                </Group>
            ) : null}
        </>
    );
};
